module.exports = new Promise((resolve, reject) => {
    const urlParams = new URLSearchParams(window.location.search);
    let remoteUrlWithVersionOutcome;

    //remoteUrlWithVersionOutcome = "http://localhost:3003/remoteEntry.js";
    const script = document.createElement("script");
    let cookies = document.cookie;
    const cookieArray = cookies.split(";").map((s) => s.split("=").map((s) => s.trim())).reduce((m, [k, v]) => (m.set(k, v), m), new Map());
    const env = cookieArray.get("VANTAGE_ENV");
    //console.log("environent ", env);

    switch (env) {
        case "local":
            remoteUrlWithVersionOutcome = "http://localhost:3003/remoteEntry.js";
            break;
        case "dev":
            remoteUrlWithVersionOutcome = "https://vantagedevor.exlservice.com/remoteEntry.js";
            break;
        case "TestAzure":
        case "cexltest":
            remoteUrlWithVersionOutcome = "https://vantagetestor.exlservice.com/remoteEntry.js";
            break;
        case "hznuat":
        case "hpuat":
        case "demouat":
            remoteUrlWithVersionOutcome = "https://vantageuatoutcomereport.exlservice.com/remoteEntry.js";
            break;
        case "hznprod":
        case "hpprod":
        case "chaprod":
            remoteUrlWithVersionOutcome = "https://vantageprodoutcomereport.exlservice.com/remoteEntry.js";
            break; 
        case "test":
            remoteUrlWithVersionOutcome = "https://testoutcomereport-infolock.lockton.com/remoteEntry.js";
            break;
        case "Prod":
            remoteUrlWithVersionOutcome = "https://outcomereport-infolock.lockton.com/remoteEntry.js";
            break;
        case "DR":
            remoteUrlWithVersionOutcome = "https://proddroutcomereport-infolock.lockton.com/remoteEntry.js";
            break;
        case "DRPROD":
            remoteUrlWithVersionOutcome = "https://proddroutcomereport-infolock.lockton.com/remoteEntry.js";
            break;        
        default:
            // fallback to localhost:3003 when no VANTAGE_ENV cookie is present
            remoteUrlWithVersionOutcome = "http://localhost:3003/remoteEntry.js";
            break;
    }
    script.src = remoteUrlWithVersionOutcome + "?v=19.4";
    script.onload = () => {
        // the injected script has loaded and is available on window
        // we can now resolve this Promise
        const proxy = {
            get: (request) => window.OUTCOME.get(request),
            init: (arg) => {
                try {
                    return window.OUTCOME.init(arg);
                } catch (e) {
                    console.log("remote container already initialized");
                }
            },
        };
        resolve(proxy);
    };
    script.onerror = () => {
        reject(new Error("Failed to load Outcome remote entry: " + script.src));
    };
    // inject this script with the src set to the versioned remoteEntry.js
    document.head.appendChild(script);
});